module.exports = "/_next/static/images/civilConstructionWireless-307284a1e4fe8e0c845d4b1045893d39.webp";